import create from "zustand";
import { format, getDaysInMonth, getMonth, getYear, isBefore } from "date-fns";
import { Webinar } from "../util/webinars";
import { useWebinarStore } from "./useWebinars";

type StoreState = {
  // Webinar dialog
  isWebinarDialogOpen: boolean;
  openWebinarDialog: (webinarId: number, day: Date) => void;
  closeWebinarDialog: () => void;

  activeWebinar?: any;
  dayOfActiveWebinar?: Date;

  // Month
  canGoToPreviousMonth: () => boolean;
  selectedMonth: {
    formatted: string;
    value: number;
  };
  setSelectedMonth: (month: number) => void;
  // Year
  selectedYear: {
    formatted: string;
    value: number;
  };
  setSelectedYear: (year: number) => void;
  // Utils
  daysInMonth: () => number;
};

const useStore = create<StoreState>((set, get) => ({
  // Webinar dialog
  isWebinarDialogOpen: false,
  openWebinarDialog: (webinarId, dayOfActiveWebinar) => {
    const webinars = useWebinarStore.getState().webinars;

    set((state) => ({
      ...state,
      isWebinarDialogOpen: true,
      activeWebinar:
        webinars.filter((webinar: Webinar) => webinar.ID === webinarId)[0] ||
        undefined,
      dayOfActiveWebinar,
    }));
  },
  closeWebinarDialog: () => {
    set((state) => ({
      ...state,
      isWebinarDialogOpen: false,
      activeWebinar: undefined,
      dayOfActiveWebinar: undefined,
    }));
  },

  activeWebinar: undefined,
  dayOfActiveWebinar: undefined,

  // Dates
  canGoToPreviousMonth: () => {
    const selectedMonth = get().selectedMonth.value;
    const selectedYear = get().selectedYear.value;
    const currentMonth = new Date();
    const previousMonth = new Date(selectedYear, selectedMonth, 1);
    const isMonthPast = isBefore(previousMonth, currentMonth);

    return !isMonthPast;
  },
  selectedMonth: {
    formatted: format(new Date(), "MMMM"),
    value: getMonth(new Date()),
  },

  setSelectedMonth: (month) =>
    set((state) => {
      const year = get().selectedYear.value;
      const currentMonthDateObject = new Date(year, month, 1);

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      return {
        ...state,
        selectedMonth: {
          formatted: format(currentMonthDateObject, "MMMM"),
          value: month,
        },
      };
    }),

  selectedYear: {
    formatted: format(new Date(), "yyyy"),
    value: getYear(new Date()),
  },
  setSelectedYear: (year) =>
    set((state) => {
      const month = get().selectedMonth.value;
      const currentYearDateObject = new Date(year, month, 1);

      return {
        ...state,
        selectedYear: {
          formatted: format(currentYearDateObject, "yyyy"),
          value: year,
        },
      };
    }),

  daysInMonth: () => {
    const selectedMonth = get().selectedMonth.value;
    const days = getDaysInMonth(selectedMonth);
    return days;
  },
}));

export default useStore;
